import React, { Fragment } from "react";
import Container from "react-bootstrap/Container";
import "./TermsTab.css";

const EventsTC = (props) => {
  return (
    <Fragment>
      <div className="tc main-pad py-md-5 py-4">
        <h3> Participation in Contest </h3>
        <ul>
          <li>
            Entry and participation in any contest shall be deemed unconditional
            and irrevocable acceptance of these T&C. All entry instructions and
            any other specific details relating to the contest or the prizes
            form part of these T&C (but in the event of any conflict or
            inconsistency, these T&C shall prevail).
          </li>
          <li>
            These Terms and Conditions (”T&C”) shall be binding on all persons
            entering any (“contest (s)”), including their guests if applicable,
            (”Participant(s)”) from time to time.
          </li>
          <li>
            All decisions of Island Star Mall Developers Pvt Ltd Pvt. Ltd in any
            matter under these T&C shall be final and no discussion or
            correspondence will be entertained.
          </li>
          <li>
            A failure by to enforce any of these T&C in any instances will not
            be construed as a waiver neither will it give rise to any claim by
            any person.
          </li>
          <li>
            Reserves the right to amend these rules at any time at its sole and
            absolute discretion without any prior intimation and Participants
            will deem to consent the same.
          </li>
          <li>
            The Participant has made certain representations and warranties to
            (both in these T&C and otherwise) in applying for a place in the
            Contest. has relied on the accuracy and truth of such
            representations and warranties in granting a place to the
            Participant. Should or its agents become aware of any fraud, deceit
            or similar action undertaken in connection with the Contest or
            otherwise, or any act or omission which might have (in opinion,
            which shall be final) an adverse effect on the Contest, reserves the
            right to forfeit the Participant’s place in the Contest (without
            giving any reason and without notice).
          </li>
          <li>
            The Participant agrees to co-operate with and comply with all
            reasonable requests of and its agents and employees (and in
            particular the health and safety team) in connection with the
            Contest and its broadcast.
          </li>
        </ul>
        <br />
        <br />
        <h3> Terms of participation in contest </h3>
        <ul>
          <li>
            The Participant undertakes the Contest at their own free will and
            agrees to indemnify and keep indemnified and its employees, agents
            against all costs, losses, damages, expenses and liabilities
            (including for loss of reputation and goodwill and professional
            advisors fees) and any claim arising from the Participant’s own
            actions in any way in connection with the Contest, the Prize or a
            breach of the Participant’s obligations hereunder.
          </li>
          <li>
            There is no fee payable to the Participant in respect of his/her
            involvement in the Contest.
          </li>
          <li>
            The Participant shall take all reasonable steps to ensure the safety
            standards and the general appropriateness of activities undertaken
            during the Contest and acknowledges that all activities are
            undertaken at her/his own risk.
          </li>
          <li>
            Is not liable in any way for any costs, expenses, damages, liability
            or injury arising out of or in any way connected with the Contest or
            for any participation in the Contest. This limitation does not
            exclude any liability for negligence or inaction by or death or
            personal injury arising out of such negligence or inaction.
          </li>
          <li>
            Reserves the right to forfeit a Participant’s place in the Contest
            or the Prize (without liability or compensation) if, in its opinion,
            the Participant may expose himself/herself or others to risk of
            illness or injury or to the cancellation, disruption, or curtailment
            of the Contest.
          </li>
          <li>
            In the case of on-line Contest Participants acknowledge that the
            internet is not a secure medium and information submitted to contest
            hosted on websites owned or controlled by may be accessed by third
            parties. accepts no liability in such cases.
          </li>
          <li>
            These T&C shall be governed and construed in accordance with Indian
            Laws.
          </li>
          <li>
            Your/Participants use of the Site is entirely at your own risk. To
            the fullest extent possible, Island Star Mall Developers Pvt Ltd
            Pvt. Ltd expressly excludes and disclaims all warranties, terms,
            conditions and representations that might otherwise be implied by
            law in relation to the Site, including, without limitation,
            warranties of technical efficiency, satisfactory quality,
            availability, non-infringement, completeness and fitness for a
            particular purpose. The material contained on the Site may contain
            inaccuracies and typographical errors. Island Star Mall Developers
            Pvt Ltd Pvt. Ltd does not warrant the accuracy or completeness of
            the content and materials on the Site. The Site may contain
            advertisements. Island Star Mall Developers Pvt Ltd Pvt. Ltd is not
            responsible for and does not endorse the content of such
            advertisements and does not accept any responsibility for any errors
            or inaccuracies in such advertisements.
          </li>
          <li>
            Island Star Mall Developers Pvt Ltd Pvt. Ltd will not be liable for
            any damages whatsoever arising out of the use or performance of the
            Site/website, the provision of or failure to provide services, or
            for any information obtained through the Site/website, or otherwise
            arising out of the use of the Site/website, whether based on
            contract, tort, or otherwise, even if Island Star Mall Developers
            Pvt Ltd Pvt. Ltd has been advised of the possibility of damage. If
            you are dissatisfied with any portion of the Site/website, or with
            any of these Terms, your sole remedy, except as specifically
            provided in these terms, is to stop using the Site/website.
            Notwithstanding anything in these Terms, Island Star Mall Developers
            Pvt Ltd Pvt. Ltd disclaims liability for death or injury caused by
            our direct negligence,fraudulent misrepresentation, and/or anything
            else that cannot be excluded or limited by Indian law.
          </li>
          <li>
            These T&C represent the entire agreement between the parties
            relating to the Contest or the Prize or any activity (unless
            otherwise expressly confirmed in writing by ) and supersede all
            prior representations, agreements, negotiations or understandings
            (whether oral or in writing). Except as specifically set out herein,
            all conditions, warranties and representations expressed or implied
            by law are excluded. For the avoidance of doubt, no information of
            any nature about the Contest or the Prize or any of these T&C should
            be relied upon unless confirmed in writing by . The invalidity,
            illegality, or unenforceability of the whole or part of a T&C or
            Condition does not affect or impair the continuation in force of the
            remainder of the T&C.
          </li>
          <li>
            The failure to exercise or delay in exercising a right or remedy
            provided hereunder or by law does not constitute a waiver of the
            right or remedy or waiver of other rights or remedies. These T&C
            shall be governed by and interpreted in accordance with Indian law
            and the parties irrevocably submit to the exclusive jurisdiction of
            the Indian courts.
          </li>
          <li>
            These T&C are not intended to nor shall create any rights,
            entitlements, claims or benefits enforceable by any person that is
            not a party to them. Accordingly, no person shall derive any benefit
            or have any right, entitlement or claim in relation to this
            Agreement by virtue of the Contracts.
          </li>
        </ul>
        <br />
        <br />
        <h3> Eligibility to Enter Contest </h3>
        <ul>
          <li>
            {" "}
            All Participants MUST be 18 years and above at the time they entered
            the contest and citizen of India and/or permanent residents of India
            and, if requested by , shall provide proof such as Aadhar card,
            Birth Certificate, Drivers License etc. of the same. In the event
            the participant is below 18 years old their participation must be
            supervised by their parents or legal guardian and in such case will
            not be held responsible for the same.
          </li>
          <li>
            Reserves the right to disqualify a Participant in the event, learns
            of Participant’s ineligibility even after awarding the prize. Any
            prize awarded shall be recovered fully by . and no claim by such
            Participant shall be entertained.
          </li>
          <li>
            The participants are solely responsible to collect their prizes or
            to check the participation date validity and observe the valid
            period. Any 2 winners with the same phone number will be considered
            fraud and both will be automatically disqualified with or without
            notification.
          </li>
          <li>
            Employees /associates or relatives of the employees/associates of
            are not eligible to participate in this contest.
          </li>
        </ul>
        <br />
        <br />
        <h3> The Contest </h3>
        <ul>
          <li>
            The interests and good reputation of are paramount and may, at its
            sole discretion, withdraw a place or require a Participant to cease
            to have any involvement in the Contest and if it believes it is in
            the best interests of to do so. In particular (without limitation),
            reserves the right to immediately withdraw a Participant’s place in
            the Contest or the Prize if it believes the Participant to be in
            breach of any of its obligations, or representations and warranties,
            under these T&C or otherwise conducts herself in a manner which is
            inappropriate or unsuitable (in the discretion of ). The Participant
            shall be responsible for any additional costs in this respect
            (including the costs of the Participant’s early return back to the
            country, if necessary).
          </li>
          <li>
            Will not be legally bound by any act /omission of the contestant
            which might bring into disrepute.
          </li>
          <li>
            The Participant will not do any act causing disrepute to .2.3 The
            Participant will comply with the instructions and directions of
            Failure to do so may lead to immediate disqualification, at
            discretion.
          </li>
          <li>
            Incomplete or indecipherable entries will be void in absolute
            discretion and any incorrect information provided by the Participant
          </li>
          <li>
            Does not accept responsibility for entries lost, damaged or delayed
            in transit to the contest address. Proof of posting will not be
            accepted as proof of receipt nor will proof that an e-mail has been
            sent rather than received.
          </li>
          <li>
            All entries send via the internet are at the will and consequences
            of the Participant and in the event there are any technical
            difficulties experienced arising out of the internet or from any
            associated equipment or internet security is compromised, may at its
            absolute discretion disqualify the entire entry and shall not accept
            any liability in doing so.
          </li>
          <li>
            Late entries will not be entertained /accepted (in discretion).
          </li>
          <li>
            In the case of a prize draw, the first correct entry drawn will be
            the winner.
          </li>
          <li>
            The decision of judges is final and conclusive in all circumstances
            and no correspondence will be entered into/entertained.
          </li>
          <li>
            has the exclusive right, to withdraw a contest with immediate effect
            by on air announcement (in the case of on-air contests) or by
            stating the same on the relevant website (in the case of on-line
            contests) without any liability in respect thereof except in case of
            emergency.
          </li>
          <li>
            Assuming a valid claim has already been made, reserves the right to
            offer an alternative prize, if possible at some other time and/or
            some other destination of equivalent value, which may be accepted
            instead by the Participant. If such alternative prize is not
            accepted (or not made) the Participant shall have no claim against
            in respect of the cancellation or delay of the Contest or prize. The
            Prize will not be exchangeable for cash or kind. In case the same is
            rejected by the winner, then may at its discretion select another
            winner or cancel the same. Any expense or financial losses or damage
            whatsoever incurred as a result thereof will not be paid /reimbursed
            by
          </li>
        </ul>
        <br />
        <br />
        <h3> Claims to Prizes </h3>
        <ul>
          <li>
            In order to enable to correctly identify genuine claims and to
            eliminate non-genuine, deceitful or fraudulent claims, reserves the
            right to carry out an interview (by telephone or in person with a
            Participant and to tape record the interview). If a Participant
            refuses to participate in or answer all questions raised in such an
            interview without valid reason then the Participants place will be
            treated as invalidated.
          </li>
          <li>
            If becomes aware of any fraud, deceit or similar action during or in
            relation to the contest which relates in any way to a claim, then
            that claim will not be met unless it is proven to the satisfaction
            of , that the Participant had no actual or imputed knowledge of the
            same. For the avoidance of doubt (and without limitation), if a
            Participant provides an incorrect name, age, contact number, address
            or other incorrect information in relation to the entry, then
            reserves the absolute right to treat that entry as invalid (whether
            or not such information comes to light before or after the
            Participant has made the claim). If the fraud, deceit or other
            action is only discovered after the prize has been released, the
            Participant undertakes to return the same (or provide compensation)
            to Island Star Mall Developers Pvt Ltd Pvt. Ltd forthwith upon
            discovery by Island Star Mall Developers Pvt Ltd Pvt. Ltd
          </li>
        </ul>
        <br />
        <br />
        <h3> Prizes </h3>
        <ul>
          <li>
            All Prize Collection must be done in person at our prize collection
            counter: <br /> Concierge Desk, Phoenix Marketcity Bangalore,
            Whitefield Main Road, Mahadevpura, Bangalore – 560048
          </li>
          <li>
            All prizes must be collected within the stipulated time. Prizes not
            collected within the stipulated period will be forfeited. shall not
            be obliged to notify winners of the collection deadline. It is the
            sole responsibility of the Winners to collect their prize.
          </li>
          <li>
            Special situations, and subject to the prior authorization of , a
            winner may nominate a designated representative in writing to
            collect their prize. A copy of Authorization Letter and id proof for
            both the winners and their representative will be required at the
            time of collection.
          </li>
          <li>
            All prizes are non-transferable to a third party and are not
            exchangeable for cash /consideration. In the event that the prize is
            unavailable, may, in its sole discretion, substitute a reasonable
            replacement for any of the prizes at any time.
          </li>
          <li>
            All winners should be able to identify the prize won and the segment
            it was won on, when calling to enquire about prizes.
          </li>
          <li>
            If a Winner chooses not to accept a Prize, they forfeit any and all
            claims to that Prize, which will be dealt with according to the
            absolute discretion of .
          </li>
          <li>
            Reserves the right to substitute or replace any prize with one of
            equal retail value. No complaints will be entertained on such
            matters.
          </li>
          <li>
            Winners are solely responsible for all taxes payable as a result of
            a Prize being awarded or received.
          </li>
          <li>
            Will not entertain any complaints on the quality and quantity of the
            prizes.
          </li>
          <li>
            All Winners may be required by /prize sponsor to participate in
            interviews, photo or video sessions and acknowledge that /prize
            sponsor has the right to use such interviews, publicity photos and
            videos in any reasonable manner it sees fit, without payment of any
            compensation.
          </li>
          <li>
            is not subject to any liability or guarantee arising out of the use
            of the awarded prizes. is not liable in any way for any costs,
            damages, loses, injuries suffered by winner.
          </li>
        </ul>
        <br />
        <br />
        <h3> Confidentiality</h3>
        <ul>
          <li>
            {" "}
            The Participants undertake not at any time to disclose, reveal,
            communicate or otherwise make public any information relating to ,
            its business, personnel, servants, agents or officers to anyone.{" "}
          </li>
        </ul>
        <br />
        <br />
        <h3> Publicity </h3>
        <ul>
          <li>
            Winners shall as a condition of the prize participate in all
            required publicity.
          </li>
          <li>
            The Participant shall not without the specific prior written consent
            of publish or disclose any information in connection with the
            Contest or the Prize (in particular, without limitation, to a
            representative of the media, in whatever form).
          </li>
          <li>
            The Participant shall not be entitled to give interviews or be
            involved in articles or reports in respect of the Contest or the
            Prize with any third party. All rights in relation to the Contest
            and the Participant’s involvement therein shall vest exclusively
            with.
          </li>
          <li>
            The Participant agrees to undertake as requested by all interviews,
            Contests and other activities and to the reproduction / publication
            / exhibition / transmission and broadcast by all means and media
            throughout the world at the discretion of in perpetuity.
          </li>
          <li>
            The Participant hereby grants and assigns to (to the extent that it
            is has the rights to grant the same) the entire copyright and other
            intellectual property rights in the Contest and her involvement in
            the Contest (including, without limitation, all interviews,
            pictures, audio, audio-visual, whether the Participant’s appearance
            is featured or incidental) in all media and technology (the
            “Products”), and where such Products are not in existence at the
            date of this Agreement, by way of present assignment of future
            assignment. This assignment shall include the right for to amend or
            otherwise adapt such Products and/or use such Products in
            conjunction with any other material and to use, distribute and/or
            broadcast such products in all media and all formats (including
            transmission by way of digital audio broadcasting, internet,
            satellite, television, film, cable or telephone) and to license any
            other persons to do so, in each case for such purposes as may in its
            absolute discretion determine.
          </li>
          <li>
            Without limitation to any other rights under this Agreement, shall
            be entitled to refer to the Participant’s association with the
            Contest and the Prize in all publicity, marketing and Contest
            material in connection therewith.
          </li>
        </ul>
      </div>
    </Fragment>
  );
};

export default EventsTC;
